<template>
  <div id="app">
    <NavBar />
      <router-view/>
    <Footer/>
  </div>
</template>

<script scoped>
import Footer from '@/components/Design/Footer.vue'
import NavBar from '@/components/Design/NavBar.vue'
export default {
  components: {
    Footer,
    NavBar
  }
}
</script>

<style>
#app {
  padding: 20px 20px 20px;
}

/*** GLOBAL TRANSITIONS ***/
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0,5s ease-out;
}

.fade-leave-to {
  opacity: 0;
}
</style>
